import React, { useState, useEffect } from 'react';
import AddNewItem from './AddNewItem';
import Item from './Item';
import './ToDoList.scss';

function List() {

  const [list, setList] = useState([])

  const AddItem = newItem => {
    setList([...list, newItem])
  }

  const RemoveItem = removedItem => {
    setList(list.filter(existingItem => existingItem.item !== removedItem.item))
  }

  const EditItem = (originalItem, editedItem) => {
    let editedList = list.map(item => {
      if (item.item === originalItem.item) {
        return {item: editedItem.item, completed: editedItem.completed}
      }
      return item
    })
    setList(editedList)
  }

  const CompleteItem = completedItem => {
    let updatedList = list.map(item => {
      if (item.item === completedItem.item) {
        return {...item, completed: true}
      }
      return item
    })
    setList(updatedList)
  }

  useEffect(() => {
    setList(localStorage.getItem('list') ? JSON.parse(localStorage.getItem('list')) : [])
  }, [])

  useEffect(() => {
    localStorage.setItem('list', JSON.stringify(list))
  }, [list])

  return (
    <main id="todo">
      <div className="intro">
        <h1>To Do List</h1>
        <AddNewItem AddItem={AddItem} />
      </div>
      {list.map((item, i) => (
        <Item 
          key={i}
          item={item}
          EditItem={EditItem}
          CompleteItem={CompleteItem}
          RemoveItem={RemoveItem}
        />
      ))}
    </main>
  )
}

export default List
